module.exports = __webpack_public_path__ + "img/play-store.ea4b0dce.svg";